(function ($) {
    'use strict';

    $(function () {
        const $datepicker = $('.js-datepicker input');
        const currentYear = new Date().getFullYear();

        $datepicker.datepicker({
            dateFormat: 'dd/mm/yy',
            changeYear: true,
            yearRange: `${currentYear - 100}:${currentYear}`
        });
    });
})(jQuery);
